import { render, staticRenderFns } from "./AppBuilds.vue?vue&type=template&id=1ed155d6&scoped=true&"
import script from "./AppBuilds.vue?vue&type=script&lang=js&"
export * from "./AppBuilds.vue?vue&type=script&lang=js&"
import style0 from "./AppBuilds.vue?vue&type=style&index=0&id=1ed155d6&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed155d6",
  null
  
)

export default component.exports